import UpdateInsuredForm from 'components/features/update-insured-form';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

const UpdateInsured = () => {
  const { t } = useTranslation();
  return (
    <HomeLayout title={t('insured.insuredRecords')}>
      <UpdateInsuredForm />
    </HomeLayout>
  );
};

export default UpdateInsured;
